import { render } from "./MyPatientsListing.vue?vue&type=template&id=55a4b11e"
import script from "./MyPatientsListing.vue?vue&type=script&lang=js"
export * from "./MyPatientsListing.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__